var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13ZM13 6.5C16.575 6.5 19.5 9.425 19.5 13C19.5 16.25 17.1438 19.0125 13.8938 19.5V14.8687H15.4375L15.7625 13H13.975V11.7812C13.975 11.2937 14.2188 10.8063 15.0312 10.8063H15.8438V9.18125C15.8438 9.18125 15.1125 9.01875 14.3813 9.01875C12.9188 9.01875 11.9437 9.9125 11.9437 11.5375V13H10.3187V14.8687H11.9437V19.4187C8.85625 18.9312 6.5 16.25 6.5 13C6.5 9.425 9.425 6.5 13 6.5Z",
    fill: "#919BB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.0851b055ebd63960b67cabdd592a0811.svg";
export { ForwardRef as ReactComponent };